import { render, staticRenderFns } from "./AddBranch.vue?vue&type=template&id=1cd39739&scoped=true"
import script from "./AddBranch.vue?vue&type=script&lang=js"
export * from "./AddBranch.vue?vue&type=script&lang=js"
import style0 from "./AddBranch.vue?vue&type=style&index=0&id=1cd39739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd39739",
  null
  
)

export default component.exports